
import app from './../index';

export default class LoginController {

  constructor() {
    app.logout();

    this.username = "";
    this.password = "";
  }

  submit() {
    app.login(this.username, this.password)
      .then(() => {
        app.$location.path('/');
      });
  }
}



// WEBPACK FOOTER //
// ./app/login/LoginController.js